//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Multiplier } from '../wheel.entity';

export default {
  name: 'WheelHomeBetContent',
  props: {
    // 对应原本从 WheelState 获取的状态
    value: {
      type: Number,
      default: Multiplier.X2
    },
    // 是否开启主播/隐身模式
    streamerMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      Multiplier,
      internalColor: this.value
    };
  },
  computed: {
    activeColor() {
      return this.value !== undefined ? this.value : this.internalColor;
    }
  },
  watch: {
    value(newVal) {
      this.internalColor = newVal;
    }
  },
  methods: {
    setColor(color) {
      this.internalColor = color;
      this.$emit('input', color);
      this.$emit('change', color);
    },
    formatMultiplier(val) {
      if (this.streamerMode) {
        return val.replace(/x/gi, '');
      }
      return val;
    }
  }
};
